<template>
  <v-card flat class="ma-0 d-flex flex-column" style="height:100%">
    <v-card-title class="primary white--text rounded-0 d-flex align-start py-1">
      {{ selected_private_user.full_name}}
    </v-card-title>
    <v-card-text
      class="chat-area d-flex flex-column-reverse grey lighten-4"
    >
      <v-card v-for="message in messages" :key="message.attendee_msg_id" flat class="grey lighten-4">
        <v-list-item
          :key="message.attendee_msg_id"
          v-if="message.send_by != myself.attendee_id"
          class="pa-0"
        >
          <v-list-item-avatar class="align-self-start mr-2 elevation-1">
            <v-avatar size="40">
              <v-img :src="selected_private_user.profile_pic"></v-img>
            </v-avatar>
          </v-list-item-avatar>
          <v-list-item-content class="received-message">
            <v-card color="success" class="flex-none">
              <v-card-text class="white--text pa-2 d-flex flex-column">
                <span class="text-caption"
                  >{{ selected_private_user.first_name }}
                </span>
                <span class="align-self-start text-subtitle-1">{{
                  message.message
                }}</span>
                <span class="text-caption font-italic align-self-end">{{
                  getTime(message.created_at)
                }}</span>
              </v-card-text>
            </v-card>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-else :key="message.attendee_msg_id" class="pa-0">
          <v-list-item-content class="sent-message justify-end">
            <v-card color="primary" class="flex-none">
              <v-card-text class="white--text pa-2 d-flex flex-column">
                <span class="text-subtitle-1 chat-message">{{
                  message.message
                }}</span>
                <span class="text-caption font-italic align-self-start">{{
                  getTime(message.created_at)
                }}</span>
              </v-card-text>
            </v-card>
          </v-list-item-content>
          <v-list-item-avatar class="align-self-start ml-2 elevation-1">
            <v-img :src="myself.profile_pic"></v-img>
          </v-list-item-avatar>
        </v-list-item>
      </v-card>
      <v-btn text color="primary" @click="loadMoreMessage" v-if="isReadMore > 0">Load More</v-btn>
    </v-card-text>
    <v-card-actions class="chat-footer success lighten-5 pa-0">
      <v-row class="d-flex flex-row justify-space-between" no-gutters>
        <v-col cols="12">
          <v-textarea
            placeholder="Type your message"
            v-model="new_message"
            @keydown.enter.exact.prevent
            @keyup.enter.exact="sendMessage()"
            @keydown.enter.shift.exact="newlineMessage"
            :loading="send_loading"
            hide-details=""
            rows="2"
            autofocus
            class="px-2"
            ref="textbox"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "@/helper/axios";
import { mapState,mapMutations} from "vuex";
export default {
  name: "ChatBox",
  data() {
    return {
      messages: [],
      new_message: "",
      total_records : 0,
      send_loading: false,
      socket_messages: [],
      attendee_data : {},
      is_subscribed : false
    };
  },
  watch : {
    selected_private_user : function(){
      this.getMessages();
      this.subscribeToIncoming();
      this.$refs['textbox'].focus()
    },
    messages : function(){
      this.clearReadCount(this.selected_private_user.attendee_id)
    }
  },
  computed: {
    ...mapState('notifications',['selected_private_user',"is_msg_expand","incoming_rintone"]),
    myself() {
      return JSON.parse(localStorage.getItem("flaacos_user"));
    },
    newMessageWithoutSpace() {
      return this.new_message.trim();
    },
    messageLength() {
      return this.newMessageWithoutSpace.length;
    },
    reverse_messages() {
      let messages = this.messages;
      let msgArray = [];
      for (let i = messages.length; i--; ) {
        msgArray.push(messages[i]);
      }
      return msgArray;
    },
    isReadMore(){
      return (this.total_records - this.messages.length)
    }
  },
  methods: {
    ...mapMutations('notifications',['clearReadCount']),
    setSocketMessage(data) {
      if(
        (data.send_by == this.myself.attendee_id && data.receive_by == this.selected_private_user.attendee_id) ||
        (data.receive_by == this.myself.attendee_id && data.send_by == this.selected_private_user.attendee_id)
        ){
          if(data.receive_by == this.myself.attendee_id && data.send_by == this.selected_private_user.attendee_id && this.is_msg_expand == 0){
            this.incoming_rintone.play()
            this.readMessage(data)
          }
        this.messages.unshift(data);
      }
    },
    getTime(time) {
      let msg_date = this.moment.utc(time);
      let today = this.moment(new Date());
      if (msg_date.isSame(today, "day")) {
        return this.moment.utc(time).local().format("hh:mm A");
      } else {
        return this.moment.utc(time).local().format("DD, MMM hh:mm A");
      }
    },
    newlineMessage() {
      this.new_message = `${this.new_message}`;
    },
    sendMessage() {
      if (this.newMessageWithoutSpace.length) {
        this.send_loading = true;
        let data = {
          message: this.newMessageWithoutSpace,
          receive_by: this.selected_private_user.attendee_id,
        };
        axios
          .post("/attendee/add_message", data)
          .then(() => {
            this.new_message = "";
            // this.messages.unshift(data.data.data)
          })
          .then(() => {
            this.send_loading = false;
          });
      }
    },
    getMessages() {
      axios
        .get("/attendee/message_list", {
          params: {
            attendee_id: this.selected_private_user.attendee_id,
          },
        })
        .then((data) => {
          this.messages = data.data.data;
          this.total_records = data.data.totalRecord
        });
    },
    loadMoreMessage(){
      axios
        .get("/attendee/message_list", {
          params: {
            attendee_id: this.selected_private_user.attendee_id,
            start_from : this.messages.length
          },
        })
        .then((data) => {
          this.messages.push(...data.data.data)
        });
    },
    readMessage(data){
      axios
        .post("/attendee/message_read", {
         message_id : data.attendee_msg_id
        })
    },
    subscribeToIncoming() {
      let subscription = this.$ws.socket.getSubscription(`user:${this.myself.attendee_id}`);
      if (!subscription) {
        this.$ws.subscribe(`user:${this.myself.attendee_id}`);
        this.$ws.$on(
          `user:${this.myself.attendee_id}|new_message`,
          this.setSocketMessage
        );
        this.is_subscribed = true
      } else {
        if(!this.is_subscribed){
          this.$ws.$on(
            `user:${this.myself.attendee_id}|new_message`,
            this.setSocketMessage
          );
          this.is_subscribed = true
        }
      }
    }
  },
  mounted: function() {
      this.getMessages();
      this.subscribeToIncoming();
  }
};
</script>

<style scoped>
.flex-none {
  flex: unset;
}
.chat-area {
  overflow-y: auto;
  min-height: 50vh;
  max-height: 50vh;
}
.received-message::after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: 40px;
  right: auto;
  top: 12px;
  bottom: auto;
  border: 12px solid;
  border-color: #4caf50 transparent transparent transparent;
}
.sent-message::after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: auto;
  right: 40px;
  top: 12px;
  bottom: auto;
  border: 12px solid;
  border-color: #294c9e transparent transparent transparent;
}
</style>
